const generateTokenExpirationDate = (expiresIn) => {
  const tokenExpirationDate = new Date();
  tokenExpirationDate.setSeconds(tokenExpirationDate.getSeconds() + expiresIn);

  return tokenExpirationDate.toUTCString();
};

export default generateTokenExpirationDate;
